import { Alert, Button, Col, Form, Input, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { upateUserPassword } from '../../../../../api/user/user';
import { openNotificationWithIcon } from '../../../../../utils/helper';

const Studentsecurity = () => {
	const [form] = Form.useForm();

	const [loading, setLoading] = useState(false)
	const [editMode, setEditMode] = useState(false)
	const [error, setError] = useState<any>(null)
	const [errors, setErrors] = useState({
		currentPassword: '',
		newPassword: '',
		confirmPassword: '',
	})

	const onFinish = async (values: any) => {
		const { currentPassword, newPassword, confirmPassword } = values
		try {
			setLoading(true)
			setError(null)
			setErrors(prevState => ({
				...prevState,
				currentPassword: '',
				newPassword: '',
				confirmPassword: '',
			}))

			const newErrors: any = {}

			if (newPassword !== confirmPassword) {
				newErrors.newPassword = 'New Password and Confirm Password should be the same'
				newErrors.confirmPassword = 'New Password and Confirm Password should be the same'
			} else {
				if (newPassword.length < 8) {
					newErrors.newPassword = 'Password should be at least 8 characters long'
				}
			}

			if (Object.values(newErrors).length === 0) {
				const res = await upateUserPassword({
					currentPassword,
					newPassword
				})

				const { message } = res.data

				openNotificationWithIcon("success", "Update Personal Information", message)

				setEditMode(false)

				form.resetFields()

				form.setFieldsValue({
					currentPassword: '********'
				})

			} else {
				setErrors(prevState => ({
					...prevState,
					...newErrors
				}))
			}

			setLoading(false)
		} catch (error: any) {
			setLoading(false)
			const otherErrors: any[] = []
			if (error?.response) {
				if (error?.response?.data?.errors) {
					const resError = error?.response?.data?.errors

					Object.entries(resError).forEach(([key, value]) => {
						if (Object.keys(errors).includes(key)) {
							setErrors(prevState => ({
								...prevState,
								[key]: value
							}))
						} else {
							otherErrors.push(value)
						}
					})

					if (otherErrors.length > 0) {
						const errorList = otherErrors.map((element: any, index) => {
							return <li key={`error-list-${index}`}>{element}</li>
						});
						setError(errorList)
					}

				} else {
					setError(error?.response?.data?.message || 'Something went wrong')
				}
			} else {
				setError('Something went wrong')
			}
		}
	}

	useEffect(() => {
		form.setFieldsValue({
			currentPassword: '********'
		})

	}, [form])


	return (
		<div>
			<p className='font-semibold text-appcolorblack text-[20px] leading-[28px] mb-[1.8rem]'>Security</p>

			<div className='border border-appcolorgreyfaintfive rounded-[12px] px-5 py-[1.3rem] bg-appcolorwhite'>

				<div className='mb-[1.6rem] flex justify-between items-center'>
					<p className='text-appcolorblack text-[18px] leading-[110%] font-semibold'>
						Password
					</p>
				</div>

				<div>
					{
						error !== null ?
							<div className='mb-4'>
								<Alert message={error} type="error" />
							</div>
							: null
					}

					<Form
						layout="vertical"
						form={form}
						onFinish={onFinish}
					>
						<Row align="middle">
							<Col lg={12} md={24} xs={24}>
								<Form.Item
									label="Current Password"
									name="currentPassword"
									rules={[{ required: true, message: 'Input is required' }]}
									validateStatus={errors?.currentPassword.length > 0 ? 'error' : undefined}
									help={errors?.currentPassword.length > 0 ? errors?.currentPassword : undefined}
								>
									<Input.Password
										disabled={!editMode}
										onChange={() => {
											setErrors(prevState => ({
												...prevState,
												currentPassword: '',
											}))
										}}
										placeholder="Current password"
									/>
								</Form.Item>
							</Col>
							{
								!editMode ?
									<Col lg={12} md={24} xs={24}>
										<div className='flex justify-end'>
											<Button
												className='custom-primary-two-btn'
												onClick={() => {
													setEditMode(true)
													form.setFieldsValue({
														currentPassword: undefined
													})
												}}
											>
												Change Password
											</Button>
										</div>
									</Col>
									: null
							}
						</Row>

						{
							editMode ?
								<>
									<Row>
										<Col lg={12} md={24} xs={24}>
											<Form.Item
												label="New Password"
												name="newPassword"
												rules={[{ required: true, message: 'Input is required' }]}
												validateStatus={errors?.newPassword.length > 0 ? 'error' : undefined}
												help={errors?.newPassword.length > 0 ? errors?.newPassword : undefined}
											>
												<Input.Password
													onChange={() => {
														setErrors(prevState => ({
															...prevState,
															newPassword: '',
														}))
													}}
													placeholder="New password"
												/>
											</Form.Item>
										</Col>
									</Row>

									<Row>
										<Col lg={12} md={24} xs={24}>
											<Form.Item
												label="Confirm Password"
												name="confirmPassword"
												rules={[{ required: true, message: 'Input is required' }]}
												validateStatus={errors?.confirmPassword.length > 0 ? 'error' : undefined}
												help={errors?.confirmPassword.length > 0 ? errors?.confirmPassword : undefined}
											>
												<Input.Password
													onChange={() => {
														setErrors(prevState => ({
															...prevState,
															confirmPassword: '',
														}))
													}}
													placeholder="Confirm password"
												/>
											</Form.Item>
										</Col>
									</Row>
								</> :
								null
						}
					</Form>

					{
						editMode ?
							<div className='flex justify-end'>
								<Button
									onClick={() => {
										setEditMode(false)
										form.setFieldsValue({
											password: '********'
										})
									}}
									style={{
										color: '#200E32 !important'
									}}
									disabled={loading}
									className='mr-[0.9rem] custom-white-btn black-text smaller-padding'>

									Cancel
								</Button>

								<Button
									disabled={loading}
									className='custom-primary-two-btn smaller-padding'
									loading={loading}
									onClick={() => {
										form.submit()
									}}
								>
									Save
								</Button>
							</div>
							:
							null
					}
				</div>
			</div>
		</div>
	)
}

export default Studentsecurity